/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackBarAlertContext } from "../../../contexts/SnackbarContext";
import request from "../../../request";

const useLazyQuery = (
  endPoint: string,
  reDirectTo?: string,
  variables?: any
) => {
  const snackBarAlertContext = useContext(SnackBarAlertContext);

  const navigate = useNavigate();
  const [response, setResponse] = useState({
    loading: false,
    error: null,
    data: null,
  });
  const fetchData = async (
    newVariables?: any,
    options?: { silent?: boolean }
  ) => {
    try {
      if (!options?.silent) {
        setResponse({
          loading: true,
          data: null,
          error: null,
        });
      }

      let apiResponse = await request.get(
        endPoint,
        newVariables ? newVariables : variables
      );

      const result = apiResponse?.data?.data ?? apiResponse?.data;

      setResponse({
        loading: false,
        data: result,
        error: null,
      });

      return result;
    } catch (error: any) {
      setResponse({ loading: false, data: null, error: error });

      if (reDirectTo) {
        navigate(reDirectTo);
      }

      snackBarAlertContext.set({
        status: true,
        type: "error",
        message: error.message,
      });

      return undefined; // Optionally return here for clarity
    }
  };

  return { ...response, fetchData };
};

export default useLazyQuery;
